module.exports = __webpack_public_path__ + "eb7063258619b81774311261c4a3cf2e.svg";